import { useEffect, useState } from "react";
import { navigate } from "../services/navigation";
import useVariation from "./useVariation";

type Options = {
  onDisabled?: {
    navigateTo?: string;
  };
};

const useRequireEnabledVariation = (
  featureKey: string,
  { onDisabled }: Options,
) => {
  const enableQuiz = useVariation(featureKey, null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (enableQuiz === false && onDisabled?.navigateTo) {
      navigate(onDisabled.navigateTo);
    }

    setEnabled(Boolean(enableQuiz));
  }, [enableQuiz, onDisabled?.navigateTo]);

  return enabled;
};

export default useRequireEnabledVariation;
